var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#100F15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) scale(0.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "copy-plus",
    d: "m18.375 6.25h-8.75a3.044 3.044 0 0 0 -3.375 3.375v8.75a3.044 3.044 0 0 0 3.375 3.375h8.75a3.044 3.044 0 0 0 3.375-3.375v-8.75a3.044 3.044 0 0 0 -3.375-3.375zm1.875 12.125c0 1.332-.543 1.875-1.875 1.875h-8.75c-1.332 0-1.875-.543-1.875-1.875v-8.75c0-1.332.543-1.875 1.875-1.875h8.75c1.332 0 1.875.543 1.875 1.875zm-16.5-12.755v8.76c0 1.2.483 1.493.642 1.59a.751.751 0 0 1 -.784 1.28 3.106 3.106 0 0 1 -1.358-2.87v-8.76a3.068 3.068 0 0 1 3.37-3.37h8.76a3.1 3.1 0 0 1 2.87 1.358.75.75 0 1 1 -1.279.784c-.1-.159-.393-.642-1.591-.642h-8.76c-1.328 0-1.87.542-1.87 1.87zm13.5 8.38a.75.75 0 0 1 -.75.75h-1.75v1.75a.75.75 0 0 1 -1.5 0v-1.75h-1.75a.75.75 0 0 1 0-1.5h1.75v-1.75a.75.75 0 0 1 1.5 0v1.75h1.75a.75.75 0 0 1 .75.75z",
    fill: "rgb(0,0,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.120b4d05c16b8d8658824cb122b1c24f.svg";
export { ForwardRef as ReactComponent };